import * as React from "react";
import {
  Button,
  View,
  Text,
  ScrollView,
  StyleSheet,
  Dimensions,
} from "react-native";
import { themePattern } from "../constants/pattern";
import { PropsStackCredits } from "./../types";

const { width, height } = Dimensions.get("window");

export default function Credits({ navigation }: PropsStackCredits) {
  return (
    <ScrollView style={styles.Main}>
      <Text style={styles.pessoa}>
        A versão impressa do Disco de Aminoácidos foi desenvolvido pelas
        professoras Leila M. Beltramini e Ana Paula U. Araujo, do IFSC/USP,
        registrado junto a Biblioteca Nacional sob número 249.795, em 17/01/2002.{" "}
      </Text>
      <Text style={styles.topico}>Coordenação Geral</Text>
      <Text style={styles.pessoa}>Leila M. Beltramini</Text>
      <Text style={styles.topico}>Consultor técnico</Text>
      <Text style={styles.pessoa}>
        Simone F. Souza{"\n"}
        Thiago N. C. Garcia
      </Text>
      <Text style={styles.topico}>Desenvolvimento do Software</Text>
      <Text style={styles.pessoa}>
        Claudinei C. de Souza (versão 1.0){"\n"}
        Rodrigo C. Diogo (versão 1.0){"\n"}
        Giovanni W. Costa (versão 2.0){"\n"}
        William L. A. Ferreira (versão 2.0)
      </Text>
      <Text style={styles.topico}>
        Design de interface e conteúdo {"\n"} (versão 2.0)
      </Text>
      <Text style={styles.pessoa}>
        Gabriela C. Fatore{"\n"}
        Giovanni W. Costa{"\n"}
        Simone F. Souza{"\n"}
        William L. A. Ferreira
      </Text>
      <Text style={styles.topico}>Pesquisa e Supervisão Pedagógica</Text>
      <Text style={styles.pessoa}>Gislaine C. Santos</Text>
      <Text style={styles.topico}>Coordenação do EIC/CIBFar</Text>
      <Text style={styles.pessoa}>
        Leila M. Beltramini
        {"\n"}
        Nelma R.S. Bossolan
      </Text>
      <Text style={styles.topico}>Software de Terceiros</Text>
      <Text style={styles.pessoa}>
        The MolView Project
        {"\n"}
        {"\n"}
        {"\n"}
        {"\n"}
      </Text>
    </ScrollView>
  );
}

function Styles() {
  //Mobile
  if (themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      Main: {
        backgroundColor: themePattern.mobile.white,
        borderColor: themePattern.mobile.black,
        borderStyle: "solid",
        borderWidth: 2,
        borderRadius: 15,
        padding: 15,
        paddingBottom: 30,
        margin: 15,
        textAlign: "center",
        alignContent: "center",
      },
      topico: {
        color: themePattern.mobile.color1,
        marginTop: 20,
        fontSize: themePattern.mobile.par1,
        fontWeight: "bold",
        textAlign: "center",
        width: "100%",
      },
      pessoa: {
        color: themePattern.mobile.black,
        textAlign: "center",
        marginTop: 5,
        fontSize: themePattern.mobile.par2,
      },
    });
  //Tablet
  else
    return StyleSheet.create({
      Main: {
        backgroundColor: themePattern.tablet.white,
        borderColor: themePattern.tablet.black,
        borderStyle: "solid",
        borderWidth: width <= 800 ? 2 : 0,
        borderRadius: 15,
        padding: 15,
        paddingBottom: 30,
        textAlign: "center",
        alignContent: "center",
        margin:
          width > 1200
            ? themePattern.desktop.retreatDesketop
            : themePattern.desktop.retreat,
        width: width > 1200 ? 1200 : "auto",
        marginTop: 15,
        marginBottom: 15,
      },
      topico: {
        color: themePattern.tablet.color1,
        marginTop: 20,
        fontSize: themePattern.tablet.title3,
        fontWeight: "bold",
        textAlign: "center",
        width: "100%",
      },
      pessoa: {
        color: themePattern.tablet.black,
        textAlign: "center",
        marginTop: 5,
        fontSize: themePattern.tablet.par1,
      },
    });
}

const styles = Styles();
